import { get } from 'lodash'

export const isSubmittingAddressSelector = state =>
  get(state, 'mailingAddress.isSubmitting', false) ||
  (get(state, 'application.country', 'US') === 'CA' &&
    get(state, 'application.submittingBackgroundCheck', false))
